export const TABLET = 768;
export const BIG_TABLET = 1024;
export const DESKTOP = 1280;
export const DESKTOP_WIDE = 1440;

export const BREAKPOINTS = {
  TABLET,
  BIG_TABLET,
  DESKTOP,
  DESKTOP_WIDE,
};
